/**
 *
 * User: mphee
 * Date: 1/8/13
 * Time: 9:13 PM
 *
 * Updated: arey
 * Date: 10/23/14
 *
 */
define(function(require){
    var _ = require('underscore'),
        Backbone = require('backbone'),
        Alert = require('common/views/Alert'),

        Country = require('location-service/models/Country'),
        StudentInfo = require('common/models/Student'),
        helper = require('common/mixins/helper'),
        Const = require('common/Const');

    return {
    	mode: null,
    	language: commonConfig.getNLS(),
    	usPhone: '1-877-500-4645',

        loadCountry: function(locationId, text, elementId){
        	var me = this;

            this.model = new Country();
              this.model.url = "/location-service/countries/" + locationId;
              this.model.fetch({
                  success: function (model, response) {
                          	me.lookupCountryNumber(model, text, elementId);
                  }
              });
		},

		lookupCountryNumber: function(model, text, elementId){
           	if( model === undefined ){
           		return this.usPhone;
           	}

        	var oeFromModel = model.models[0].attributes.phone.oeServicePhone;

            if(oeFromModel && oeFromModel.trim().length > 0){
            		$(elementId).html(text + oeFromModel);
            	}else{
            		$(elementId).html(text + this.usPhone);
            	}
         },
		getLocationContactPhoneLocationService: function(locationId){
        	var me = this;

			this.model = new Country();
            this.model.url = "/location-service/countries/" +locationId;

            this.model.fetch({
                success: function (model, response) {
                   helper.debug("Response is "+ JSON.stringify(model.toJSON()));

                	var oeContactPhoneNumber = model.models[0].attributes.phone.oeContactPhone;

                	Backbone.trigger('CommonFunctions:OeContactPhoneAvailable', {oeContactPhoneNumber: oeContactPhoneNumber});
                },error: function(model, response){
                	Backbone.trigger('CommonFunctions:OeContactPhoneAvailable', {oeContactPhoneNumber: me.usPhone});
                }
            });
		},
		verifyDropdown : function(dropdownDivClass) {
			var resultsFound = $(dropdownDivClass).find("span .ui-helper-hidden-accessible"),
				input = $(dropdownDivClass).find(".ui-autocomplete-input");
				if(resultsFound.text() == 'No search results.'){
					input.attr("style","background: #A80000 !important");
				}
		},

		resetInput : function(inputElement){
			inputElement.val("");
		},

        setContactPhoneLocation: function(elementId, text, textAfter) {
            var code = oeApp.getData('common').countryCode;

            if (!(code === undefined)) {
            	if(code){
            	    this.setPhoneNumber(elementId, text, code, textAfter);
	            }else{
	            	this.setPhoneNumber(elementId, text, 1, textAfter);
	            }
            }else{
            	this.setPhoneNumber(elementId, text, 1, textAfter);
            }
        },

        setPhoneNumber : function(elementId, text, code, textAfter){
            var me = this,
            	phoneNumber;

            if(code){
            	if(code == 1){
            		phoneNumber = text + me.usPhone;
            	}else{
                    phoneNumber = text + me.loadCountry(code, text, elementId);
           	}
            }else{
                phoneNumber = i18n.talkNow.callHelpLine.helpLineUnavailable;
            }

            if( textAfter ){
            	phoneNumber += textAfter;
            }

            $(elementId).html(phoneNumber);
        },

        lookupNumber: function(model, text, elementId){
        	if( model === undefined ){
        		return this.usPhone;
        	}

        	var oeFromModel = model.models[0].attributes.oeServicePhoneNumber;

        	if(oeFromModel && oeFromModel.trim().length > 0){
        		$(elementId).html(text + oeFromModel);
        	}else{
        		$(elementId).html(text + this.usPhone);
        	}
        },

        getPhoneNumber: function(countryCode){
        	if(countryCode == ''){
        		Backbone.trigger('CommonFunctions:OeContactPhoneAvailable', {oeContactPhoneNumber: this.usPhone});
        	}else{
                this.getLocationContactPhoneLocationService(countryCode);
        	}
        },

        //detects if we have a popup link inside of the dom element passed,
        // and replaces the link with a popupblocker safe version
        popupDetector : function($el){
            var me = this;
            var links = $el.find("a[target='_blank']");
            if(links && links.length > 0){
                var x = 0;
                links.each(function() {
                    var item = $(this);
                    var id = item.attr('id');
                    if(!id){
                        id = 'popupID' + x;
                        item.attr('id',id); //set the id
                        x++;
                    }

                    me.popupLink(item.attr('href'),'#' + item.attr('id'));
                });
                }
        },

        popupLinkNow : function(url, targetIn) {
            var me = this,
                target = targetIn || '_blank',
                pop = window.open(url, targetIn);

            if (pop) {
                pop.onload = function () {
                     if(pop.innerHeight > 0){/*it worked fine*/}
                     else{
                         me.popupBlockerDetected();
                     }
                }
            } else {
                var pop = window.open(url,'_blank');
                if (pop){/*it worked fine*/}
                else{
                    me.popupBlockerDetected();
                }
            }
        },

        popupLink : function(url, link){
            //used to smartly open a link in a new window includes popup detection
            var me = this;

            $(link).on("click",function(event) {
                event.preventDefault();
                event.stopPropagation();

                var target = $(this).attr('target') || '_blank';

                me.popupLinkNow(url, target);
            });
        },

        popupLinks: function($links) {
            var me = this;

            $links.each(function() {
                var $this = $(this),
                    href = $.trim($this.attr('href')),
                    target = $.trim($this.attr('target'));

                if (target && target.length > 0 && target != '_self' && target != '_top') {
                    if (href && href.length > 0 && href[0] != '#') {
                        me.popupLink(href, $this);
                    }
                }
            });
        },

        popupBlockerDetected : function(){
            // display a popup banner
            new Alert({title: i18n.popupBlocker.title, text: i18n.popupBlocker.text});
        },

        xlateUnitLevelHack: function(valueIn) {
            value = valueIn;

            if (_.isString(value)) {
                value = this.xlateHack(value, 'Level', i18n.Level);
                value = this.xlateHack(value, 'level', i18n.Level.toLowerCase());

                value = this.xlateHack(value, 'Unit', i18n.Unit);
                value = this.xlateHack(value, 'unit', i18n.Unit.toLowerCase());
            }

            return value;
        },

        xlateHack: function(valueIn, search, replacement) {
            value = valueIn;

            if (_.isString(value)) {
                value = eval('value.replace(/\\s' + search + '\\s/, " " + replacement + " ");');
                value = eval('value.replace(/\\s' + search + '$/, " " + replacement);');
                value = eval('value.replace(/^' + search + '\\s/, replacement + " ");');
                value = eval('value.replace(/^' + search + '$/, replacement);');
            }

            return value;
        },

        isEmailExists: function(email, onSuccessFn, onFailFn) {
        	var isUserValid = true;
        	$.ajax({
        		async:false,
        		type: "POST",
        		url : "/email/checkexists",
        		data : email,
        		success : function(data) {
        			if (onSuccessFn) onSuccessFn(data);
        		},
        		error : function() {
        			if (onFailFn) onFailFn();
        		}
        	});
        },

        getActiveUser: function(forceLoad) {
            if ((!forceLoad) && oeApp.hasData('person')) {
                return new StudentInfo(oeApp.getData('person'));
            } else {
                return new StudentInfo().fetch();
            }
        },

        //gets an item from the localstorage for the given name
        getItemFromLocalStorage: function(itemName) {
            return (window.localStorage) ? window.localStorage.getItem(itemName) : null;
        },

        //sets an item into the localstorage with the given name and value
        setItemIntoLocalStorage: function (itemName, itemValue) {
            if(window.localStorage) {
                window.localStorage.setItem(itemName, itemValue);
            }
        },

        //removes an item from the localstorage for the given name
        removeItemFromLocalStorage: function(itemName) {
            if(window.localStorage) {
                window.localStorage.removeItem(itemName);
            }
        },

        getLiveClassInPollingState: function(liveClasses) {
            if (!liveClasses) {
                return null;
            }
            
            for (var i = 0; i < liveClasses.length; i++) {
                var liveClass = liveClasses[i];
                var signedUp;
                var reminder;
                var classroomUrl;
                if (liveClass && liveClass.attributes) {
                    signedUp = liveClass.get('signedUp');
                    reminder = liveClass.get('reminder');
                    classroomUrl = liveClass.get('classroomUrl');
                } else {
                    signedUp = liveClass.signedUp;
                    reminder = liveClass.reminder;
                    classroomUrl = liveClass.classroomUrl;
                }

                if (signedUp && !reminder && !classroomUrl) {
                    return liveClass;
                }
            }
            return null;
        },

        isTeacherFeedbackNotification: function(notification) {
            return (notification.type === Const.NOTIFICATION_ENUM.TEACHER_FEEDBACK);

        },

        isLiveClassFeedback: function (notification) {
            return this.isTeacherFeedbackNotification(notification) && (/.*Class Feedback.*/.test(notification.title))
        },

        isAskATeacherOrWritingFeedback: function (notification) {
            return this.isTeacherFeedbackNotification(notification) && [Const.FEEDBACK_REQUEST_TYPE_ENUM.ASK_A_TEACHER, Const.FEEDBACK_REQUEST_TYPE_ENUM.WRITING_FEEDBACK].indexOf(notification.title) > -1;
        },

        getCookie: function(cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for(var i = 0; i <ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        },

        setCookie: function(cname, cvalue, exdays) {
            var d = new Date();
            d.setTime(d.getTime() + (exdays*24*60*60*1000));
            var expires = "expires="+ d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        },

        sendNotificationToAngular: function (notification, timeout) {
            if (timeout === undefined) {
              timeout = 3000;
            }
           
            // Make sure Angular is initialized before dispatching the event
            setTimeout(function () {
              window.dispatchEvent(
                new CustomEvent('notification-event', {
                  detail: {
                    data: notification,
                  },
                })
              );
            }, timeout);
        },

        sendReadConfirmationToAngular: function (notificationId, timeout) {
            if (timeout === undefined) {
                timeout = 3000;
            }

            // Make sure Angular is initialized before dispatching the event
            setTimeout(function () {
                window.dispatchEvent(
                    new CustomEvent('read-notification-event', {
                        detail: {
                            data: notificationId
                        },
                    })
                );
            }, timeout);
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./js/common/CommonFunctions.js
// module id = 308
// module chunks = 27 28 29